<template>
  <div id="app">
    <Bandeau
      v-if="payment"
      :show-rgpd.sync="showRgpd"
      :type="form.type"
      :description="form.description"
    />

    <header :class="classname">
      <h1 @click="reset">Résiliation {{ form.description }} en ligne</h1>
    </header>

    <main :class="classname">
      <el-card id="form">
        <span v-if="step === 1">
          <FormPaiement
            :loading="loading"
            :nom.sync="form.nom"
            :prenom.sync="form.prenom"
            :adresse.sync="form.adresse"
            :adresse2.sync="form.adresse2"
            :codePostal.sync="form.codePostal"
            :ville.sync="form.ville"
            :pays.sync="form.pays"
            :email.sync="form.email"
            :optin.sync="form.optin"
            :phone="form.phone"
            :contract="form.contract"
            :reference="'référence ' + form.description"
            :type="form.type"
            @valide="handlePayment"
          />
        </span>

        <Confirmation
          v-else-if="step === 2"
          :email="form.email"
        />

        <template v-else>
          <FormMobile
            v-if="form.type === 'mobile' || form.type === 'internet'"
            title="Numéro d'abonné ou de contrat sur votre facture"
            :loading="loading"
            :contact="contact"
            :phone.sync="form.phone"
            :contract.sync="form.contract"
            :type.sync="form.type"
            :services.sync="form.services"
            :description="form.description"
            :reference="'identifiant ' + form.description"
            :internet="internet"
            @valide="preparePayment"
          />

          <FormCanal
            v-else-if="form.type === 'canalsat' || form.type === 'canalplay' || form.type === 'canalfoot' || form.type === 'canal'"
            title="Numéro d'abonné dans votre espace client"
            :loading="loading"
            :contact="contact"
            :contract.sync="form.contract"
            :type.sync="form.type"
            :description="form.description"
            :reference="'identifiant ' + form.description"
            @valide="preparePayment"
          />

          <FormMutuelle
            v-else-if="form.type === 'mutuelle'"
            title="Numéro du contrat à résilier"
            :loading="loading"
            :contact="contact"
            :contract.sync="form.contract"
            :motif.sync="form.motif"
            :informations.sync="form.informations"
            :attachment.sync="form.attachment"
            :type.sync="form.type"
            :description="form.description"
            :reference="'numéro de contrat ' + form.description"
            @valide="preparePayment"
          />

          <FormSport
            v-else-if="form.type === 'sport'"
            :loading="loading"
            :contact="contact"
            :contract.sync="form.contract"
            :informations.sync="form.informations"
            :attachment.sync="form.attachment"
            :type.sync="form.type"
            :description="form.description"
            :reference="'numéro de contrat ' + form.description"
            @valide="preparePayment"
          />
        </template>
      </el-card>

      <EtapesCanal
        v-if="form.type === 'canalsat' || form.type === 'canalplay' || form.type === 'canalfoot' || form.type === 'canal'"
      />
      <EtapesCommande v-else />
    </main>

    <footer>
      <el-button type="text" @click="showCgu = true">
        Mentions légales
        <span v-if="payment">et conditions générales de vente</span>
      </el-button>
      <el-button type="text" @click="contactUs">
        Contact
      </el-button>
    </footer>

    <el-drawer
      title="Mentions légales et conditions"
      :visible.sync="showCgu"
      direction="btt"
    >
      <Cgu :contact="contact" :payment="payment" />
    </el-drawer>

    <el-drawer
      title="POLITIQUE DE CONFIDENTIALITÉ / RGPD"
      :visible.sync="showRgpd"
      direction="ttb"
    >
      <Rgpd />
    </el-drawer>
  </div>
</template>

<script>
import Vue from 'vue'
import { handleCardPayment } from 'vue-stripe-elements-plus'
import { loadStripe } from '@stripe/stripe-js'
import Bandeau from './components/bandeau'
import Cgu from './components/cgu'
import Rgpd from './components/rgpd'
import EtapesCanal from './components/etapes-canal'
import EtapesCommande from './components/etapes-commande'
import FormMobile from './components/form/mobile'
import FormCanal from './components/form/canal'
import FormMutuelle from './components/form/mutuelle'
import FormSport from './components/form/sport'
import FormPaiement from './components/form/paiement'
import Confirmation from './components/confirmation'

export default {
  name: 'App',
  components: {
    Bandeau,
    Cgu,
    Rgpd,
    EtapesCanal,
    EtapesCommande,
    FormMobile,
    FormCanal,
    FormMutuelle,
    FormSport,
    FormPaiement,
    Confirmation
  },
  data () {
    let internet = true
    let description = 'Free'
    let services = ''
    let motif = ''
    let hostname = window.location.hostname + window.location.pathname
    let type = hostname.match(/mobile/) ? 'mobile' : 'internet'
    let product = type === 'mobile' ? 'FREE_MOBILE' : 'FREE'

    if (hostname.match(/orange/)) {
      product = 'ORANGE'
      description = 'Orange'
      services = (type === 'mobile' ? 'Téléphonie mobile' : 'Internet')
    } else if (hostname.match(/sosh/)) {
      description = 'Sosh'
    } else if (hostname.match(/redbysfr/)) {
      description = 'Red by SFR'
    } else if (hostname.match(/sfr/)) {
      product = 'SFR'
      description = 'SFR'
      services = (type === 'mobile' ? 'Téléphonie mobile' : 'Internet')
    } else if (hostname.match(/bouygues/)) {
      product = 'BOUYGUES_TELECOM'
      description = 'Bouygues Telecom'
      services = (type === 'mobile' ? 'Téléphonie mobile' : 'Internet')
    } else if (hostname.match(/bandyou/)) {
      description = 'B and You'
    } else if (hostname.match(/laposte/)) {
      description = 'La Poste Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/cic/)) {
      description = 'CIC Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/creditmutuel/)) {
      description = 'Credit Mutuel Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/coriolis/)) {
      description = 'Coriolis Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/clubbudget/)) {
      description = 'Club Budget Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/nrjmobile/)) {
      description = 'NRJ Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/symamobile/)) {
      description = 'Syma Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/auchantelecom/)) {
      description = 'Auchan Telecom'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/numericablemobile/)) {
      description = 'Numericable Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/m6mobile/)) {
      description = 'M6 Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/prixtel/)) {
      description = 'Prixtel'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/simyomobile/)) {
      description = 'Simyo Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/virginmobile/)) {
      description = 'Virgin Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/wibox/)) {
      description = 'Wibox'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/leclercmobile/)) {
      description = 'Leclerc Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/transatel/)) {
      description = 'Transatel'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/alicemobile/)) {
      description = 'Alice Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/breizhmobile/)) {
      description = 'Breizh Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/cdiscountmobile/)) {
      description = 'CDiscount Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/lebaramobile/)) {
      description = 'Lebara Mobile'
      type = 'mobile'
      internet = false
    } else if (hostname.match(/alsatistelecom/)) {
      description = 'Alsatis Telecom'
      type = 'internet'
      internet = false
    } else if (hostname.match(/fransat/)) {
      description = 'Fransat'
      type = 'internet'
      internet = false
    } else if (hostname.match(/nordnet/)) {
      description = 'Nordnet'
      type = 'internet'
      internet = false
    } else if (hostname.match(/numericabletelecom/)) {
      description = 'Numericable Telecom'
      type = 'internet'
      internet = false
    } else if (hostname.match(/ovhtelecom/)) {
      description = 'OVH Telecom'
      type = 'internet'
      internet = false
    } else if (hostname.match(/ozone/)) {
      description = 'Ozone'
      type = 'internet'
      internet = false
    } else if (hostname.match(/canalsat/)) {
      product = 'CANALSAT'
      description = 'Canalsat'
      type = 'canalsat'
    } else if (hostname.match(/canalplay/)) {
      description = 'Canalplay'
      type = 'canalplay'
    } else if (hostname.match(/canalfoot/)) {
      description = 'Foot+/Rugby+'
      type = 'canalfoot'
    } else if (hostname.match(/canal/)) {
      product = 'CANAL_PLUS'
      description = 'Canal+'
      type = 'canal'
    } else if (hostname.match(/mma/)) {
      description = 'MMA'
      type = 'mutuelle'
    } else if (hostname.match(/axa/)) {
      description = 'AXA'
      type = 'mutuelle'
    } else if (hostname.match(/pacifica/)) {
      description = 'Pacifica'
      type = 'mutuelle'
    } else if (hostname.match(/directassurance/)) {
      description = 'Direct Assurance'
      type = 'mutuelle'
    } else if (hostname.match(/maif/)) {
      description = 'MAIF'
      type = 'mutuelle'
    } else if (hostname.match(/macif/)) {
      description = 'Macif'
      type = 'mutuelle'
    } else if (hostname.match(/gmf/)) {
      description = 'GMF'
      type = 'mutuelle'
    } else if (hostname.match(/groupama/)) {
      description = 'Groupama'
      type = 'mutuelle'
    } else if (hostname.match(/matmut/)) {
      description = 'Matmut'
      type = 'mutuelle'
    } else if (hostname.match(/generali/)) {
      description = 'Generali'
      type = 'mutuelle'
    } else if (hostname.match(/basicfit/)) {
      description = 'Basic Fit'
      type = 'sport'
    } else if (hostname.match(/neoness/)) {
      description = 'Neoness'
      type = 'sport'
    } else if (hostname.match(/keepcool/)) {
      description = 'Keep Cool'
      type = 'sport'
    } else if (hostname.match(/fitnesspark/)) {
      description = 'Fitness Park'
      type = 'sport'
    }
    if (type === 'mutuelle') {
      motif = 'Autres raisons'
    }
    return {
      internet,
      stripe: null,
      stripeCX: null,
      loading: false,
      payment: true,
      showCgu: false,
      showRgpd: false,
      products: {
        ORANGE: {
          priceId: 'price_1SidDMHXlwNyUEJPDsLysXbu',
          bg: '#000000',
          btn: '#FF7900',
          font: 'inter',
          border: 'rounded'
        },
        SFR: {
          priceId: 'price_1SidE7HXlwNyUEJPmHoV8qHC',
          bg: '#000000',
          btn: '#E2001A',
          font: 'inter',
          border: 'rounded'
        },
        FREE_MOBILE: {
          priceId: 'price_1SidFrHXlwNyUEJP3IuqY3ow',
          bg: '#FFFFFF',
          btn: '#0033A0',
          font: 'inter',
          border: 'rounded'
        },
        FREE: {
          priceId: 'price_1SidGRHXlwNyUEJPygBbRgjz',
          bg: '#FFFFFF',
          btn: '#0033A0',
          font: 'inter',
          border: 'rounded'
        },
        BOUYGUES_TELECOM: {
          priceId: 'price_1SidHJHXlwNyUEJPeF8yyHKi',
          bg: '#FFFFFF',
          btn: '#009FE3',
          font: 'inter',
          border: 'rounded'
        },
        CANAL_PLUS: {
          priceId: 'price_1SidIHHXlwNyUEJPcZMsvkDS',
          bg: '#FFFFFF',
          btn: '#000000',
          font: 'inter',
          border: 'rounded'
        },
        CANALSAT: {
          priceId: 'price_1SidIqHXlwNyUEJPpa3Zs2ct',
          bg: '#FFFFFF',
          btn: '#000000',
          font: 'inter',
          border: 'rounded'
        }
      },
      form: {
        type,
        services,
        motif,
        description,
        product,
        attachment: null,
        informations: null,
        paymentId: null,
        paymentSecret: null,
        phone: null,
        contract: null,
        nom: null,
        prenom: null,
        email: null,
        adresse: null,
        adresse2: null,
        codePostal: null,
        ville: null,
        pays: 'FR',
        optin: '1'
      }
    }
  },
  created () {
    this.preventReload()
    this.$nextTick(async () => {
      this.stripeCX = await loadStripe(this.$root.stripeKey)

      if (this.gclid) {
        // Vue.api.post('/g/' + this.gclid).catch(() => {})
      }
    })
  },
  computed: {
    keyword () {
      if (this.$route.query.keyword) {
        return this.$route.query.keyword
      }
      let m = window.location.href.match(/keyword=([^&#]+)/)
      if (m) {
        return m[1]
      }
    },
    gclid () {
      if (this.$route.query.gclid) {
        return this.$route.query.gclid
      }
      let m = window.location.href.match(/gclid=([^&#]+)/)
      if (m) {
        return m[1]
      }
    },
    device () {
      if (this.$route.query.device) {
        return this.$route.query.device
      }
      let m = window.location.href.match(/device=([^&#]+)/)
      if (m) {
        return m[1]
      }
    },
    hostname () {
      return window.location.hostname + window.location.pathname
    },
    classname () {
      return this.form.description.replace(/\s+/g, '').toLowerCase()
    },
    contact () {
      let domain = window.location.hostname.split('.')
      return 'contact@' + domain[domain.length - 2] + '.' + domain[domain.length - 1]
    },
    step () {
      if (!this.$route.params.etape) {
        return 0
      }

      let etape = parseInt(this.$route.params.etape)
      return isNaN(etape) ? 0 : etape
    }
  },
  methods: {
    reset () {
      this.$router.push('/')
      window.scrollTo(0, 0)
      window.location.reload(true)
    },
    notifyError (message) {
      this.$notify({
        title: 'Une erreur est survenue',
        message: message || 'Veuillez recharger la page s\'il vous plait.',
        position: 'bottom-right',
        type: 'error',
        duration: 0
      })
    },
    preparePayment () {
      this.form.hostname = this.hostname
      this.form.keyword = this.keyword
      this.form.device = this.device

      if (this.form.product && this.products[this.form.product]) {
        return this.handleCheckout(this.products[this.form.product])
      }

      if (this.payment) {
        window.scrollTo(0, 120)
        Vue.api.post('/payment/intent', this.form).then((res) => {
          this.form.paymentId = res.data.id
          this.form.paymentSecret = res.data.secret
          // window.gtag('event', 'conversion', { 'send_to': 'AW-702902281/vdelCND3s7gBEInglc8C' })
          // console.log('+ g_event')
        }).catch(() => this.notifyError())

        this.$router.push('/etape/1')
        // Vue.api.post('/c/1').catch(() => {})
      }
    },
    handlePayment () {
      this.loading = true
      Vue.api.post('/payment/update', this.form).then(() => {
        handleCardPayment(this.form.paymentSecret, {
          payment_method_data: {
            billing_details: {
              name: this.form.nom + ' ' + this.form.prenom
            }
          },
          save_payment_method: true
        }).then((result) => {
          this.loading = false
          if (result.error) {
            return this.notifyError(result.error.message)
          }

          this.$router.push('/etape/2')
          window.scrollTo(0, 0)
          // cf: composant confirmation window.gtag('event', 'conversion', { 'send_to': 'AW-11163997967/2fCFCJCau5sYEI-utMsp' })
          // console.log('+ g_event')
          // Vue.api.post('/c/2').catch(() => {})
        })
      }).catch(() => this.notifyError())
    },
    handleCheckout (product) {
      this.loading = true

      Vue.api.post('/payment/checkout', {
        ...this.form,
        ...product,
        billing_details: {
          name: this.form.nom + ' ' + this.form.prenom
        }
      }, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then((res) => {
        this.loading = false
        return this.stripeCX.redirectToCheckout({ sessionId: res.data.id })
      }).catch(() => this.notifyError())
    },
    contactUs () {
      window.location.href = 'mailto:' + this.contact
    },
    openEspaceClient () {
      window.open(this.espaceClient, '_blank')
    },
    preventReload () {
      setTimeout(() => {
        if (this.step === 1 && !this.form.paymentId) {
          this.reset()
        }
      }, 6000)
    }
  },
  watch: {
    step () {
      this.preventReload()
    }
  }
}
</script>

<style lang="scss" scoped>
  header {
    padding: 12px 0;
    margin-bottom: 0px;

    h1 {
      font-size: 32px;
      font-weight: 600;
      line-height: 55px;
      margin: 0;
      cursor: pointer;
      text-align: center;
    }

    span {
      padding-left: 1px;
    }

    .espace-client {
      text-align: right;
      margin-top: 13px;
    }

    &.freemobile {
      color: #444;
      background-color: #fff;
    }
    &.orangemobile {
      background-color: #000;
      color: #fff;
    }
    &.soshmobile {
      background-color: #26828e;
      color: #fff;
    }
    &.redbysfrmobile {
      background-color: #00e094;
      color: #fff;
    }
    &.lapostemobile {
      background-color: #3565A6;
      color: #fff;
    }
  }

  footer {
    border-top: 1px solid #707070;
    text-align: center;
    color: #707070;
    font-size: 14px;
    line-height: 40px;
    padding-bottom: 25px;
  }

  #form {
    text-align: center;
    margin-bottom: 25px;
  }

  @media (max-width: 1200px) {
    header {
      height: 80px;
      padding-top: 25px;

      h1 {
        font-size: 30px
      }
    }
  }
  @media (max-width: 767px) {
    header {
      height: 32px;
      padding-top: 5px;

      h1 {
        font-size: 20px;
      }
      .espace-client {
        display: none;
      }
    }
  }
</style>

<style lang="scss">
  #app, html, body {
    height: 100%;
    font-family: Arial, sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-feature-settings: "kern";
    -moz-font-feature-settings: "kern=1";
    -moz-font-feature-settings: "kern" 1;
    -o-font-feature-settings: "kern";
    font-feature-settings: "kern";
    text-rendering: optimizeLegibility;
    background: #f5f5f5;
    color: #00223B;
    margin: 0;
    padding: 0;
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: 400;
  }
  img.responsive {
    display: block;
    max-width: 100%;
    height: auto;
  }
  main,
  header .el-row {
    width: 1200px;
    margin: 0 auto !important;
  }
  header .el-row {
    width: 1100px;
  }
  .el-drawer__open .el-drawer.btt {
    overflow: auto;

    .el-card__body {
      font-size: 12px;
    }
  }

  #form .el-form-item {
    max-width: 600px;
    margin: 0 auto 18px;
    text-align: left;

    &.optin .el-checkbox__input {
      top: -18px;
    }
    &.optin .el-checkbox__label {
      font-weight: 400 !important;
    }
  }

  header.orange,
  main.orange {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

    h1, h2, h3, h4, h5, h6 {
      font-weight: 600;
    }

    &.orange, .el-dialog__header {
      background-color: black;
      color: white;
    }

    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: black;
      font-weight: 700;
    }
    .el-checkbox.is-bordered.is-checked {
      border-color: black;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: black;
      border-color: black;
    }

    .el-button.el-button--danger {
      border-color: black;
      background-color: black;
      color: white;
      border-radius: 0;
      font-weight: 600;
    }

    .fields-title {
      font-weight: 600;
    }
  }

  .orangemobile {
    .el-button--danger {
      background-color: #f16e00;
      border-color: #f16e00;
    }
  }
  .soshmobile {
    .el-button--danger {
      background-color: #fbcd00;
      border-color: #fbcd00;
      color: #444;
    }
  }
  .redbysfrmobile {
    .el-button--danger {
      background-color: #00e094;
      border-color: #00e094;
      color: #fff;
    }
  }
  .bouyguestelecommobile, .bandyoumobile {
    .el-button--danger {
      background-color: #009dcc;
      border-color: #009dcc;
      color: #fff;
    }
  }
  .lapostemobile {
    .el-button--danger {
      background-color: #F8CA1F;
      border-color: #F8CA1F;
      color: #444;
    }
  }
  .cicmobile {
    .el-button--danger {
      background-color: #099;
      border-color: #099;
      color: #fff;
    }
  }
  .creditmutuelmobile {
    .el-button--danger {
      background-color: #1e60a9;
      border-color: #1e60a9;
      color: #fff;
    }
  }

  @media (max-width: 1200px) {
    main,
    header .el-row {
      width: 800px;
    }
  }
  @media (max-width: 998px) {
    #form-acte {
      margin: 0;

      h2 {
        font-size: 18px;
        margin-top: 0;
      }
    }
  }
  @media (max-width: 767px) {
    header .el-row {
      width: calc(100% - 30px);
    }
    main {
      width: 100%;
    }
    main {
      .el-step__title {
        line-height: 14px;
        font-size: 14px;
      }
    }
    #form {
      h2 {
        display: none;

        & + .el-form {
          padding-top: 0;
        }
      }

      .el-form--label-left .el-form-item__label {
        width: 100% !important;

        & + div {
          margin-left: 0 !important;
        }
      }

      .el-alert__title {
        display: block;
        padding: 8px 4px;
      }
    }

    .etapes {
      margin: 0 !important;

      & + div {
        margin: 0 25px;
      }
    }

    #form {
      h2 {
        margin: 0 0 10px;
        font-size: 18px;
      }

      .el-form--label-left .el-form-item__label {
        width: 100% !important;

        & + div {
          margin-left: 0 !important;
        }
      }
    }

    .el-step.is-horizontal {
      flex-basis: calc(100vw / 3) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app.vue